import Vue from 'vue'
import router from "./router"
import App from "./App"
import i18n from './i18n'

Vue.config.productionTip = false
Vue.prototype.baseUrl = window.lang_test_base_url;
let lang = document.documentElement.lang
i18n.locale = lang

Vue.component(
    'lang_test-app',
    require('./App.vue').default
);

const app = new Vue({
    el: '#lang_test',
    i18n,
    router: router
});

